import { useState, useEffect } from 'react';
import ready from 'document-ready';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import PaymentAuthorizationSubmitButtons from '@Components/Shared/Payments/PaymentAuthorizationSubmitButtons';

const SquareForm = (props) => {
    
    const [processing, setProcessing] = useState(false);
    const [paymentForm, setPaymentForm] = useState(null);

    const [currentResponse, setCurrentResponse] = useState(null);
    const [verificationToken, setVerificationToken] = useState(null);

    useEffect(() => {
        const _paymentForm = new SqPaymentForm({
            applicationId: props.PublicKey,
            locationId: props.LoginID,
            // card input form
            inputClass: 'sq-input',
            cardNumber: {
                elementId: 'sq-card-number',
                placeholder: '0000 0000 0000 0000'
            },
            cvv: {
                elementId: 'sq-cvv',
                placeholder: '123'
            },
            expirationDate: {
                elementId: 'sq-expiration-date',
                placeholder: 'MM/YY'
            },
            postalCode: {
                elementId: 'sq-postal-code',
                placeholder: '12345'
            },
            // SqPaymentForm callback functions
            callbacks: {
                /*** callback for SqPaymentForm.requestCardNonce() ***/
                cardNonceResponseReceived: function (errors, nonce, cardData) {                   
                    if (errors) {
                        // request card nonce failure
                        console.log(errors);
                        props.setError("An Error has Occurred. Please verify payment method information above.");
                    }
                    else {
                        props.setError('');
                        // request card nonce success
                        let fullResponse = {...cardData, ...props };
                        fullResponse.PaymentMethodID = nonce;
                        setCurrentResponse(fullResponse);
                    }
                }
                /*** end callback for SqPaymentForm.requestCardNonce() **/
            }
        });
        _paymentForm.build();

        setPaymentForm(_paymentForm);

        ready(() => {
            props.ready?.();
        });
    }, []);

    useEffect(() => {
        if (processing && paymentForm) {
            if (props.savedPayment) {
                let fullResponse = { ...props };
                fullResponse.ID = props.savedPayment.ID;
                setCurrentResponse(fullResponse);
            }
            else {
                paymentForm.requestCardNonce();
            }
        }       
    }, [processing]);

    useEffect(() => {
        if (processing && paymentForm && currentResponse) {
            if (props.savedPayment) {
                verifySavedPaymentMethod(props.savedPayment);
            }
            else {
                verifyPaymentMethod(currentResponse.PaymentMethodID);
            }
        }
    }, [currentResponse]);

    useEffect(() => {
        if (processing && paymentForm && currentResponse && verificationToken) {
            setProcessing(false);
            props.setLoading(false);

            currentResponse.VerificationToken = verificationToken;
            if (props.savedPayment) {
                props.successWithSavedPayment?.(currentResponse);
            }
            else {
                props.success?.(currentResponse);
            }         
        }
    }, [verificationToken]);

    const submitForm = () => {
        if (!processing && !props.loading) {
            if (props.savedPayment) {
                requestCardToken();
            }
            else {
                props.validateForm(requestCardToken);
            }
        }      
    };

    const requestCardToken = () => {
        props.setLoading(true);
        setProcessing(true);
    };

    const verifyPaymentMethod = (nonce) => {
        // verify the newly created nonce
        let verification_details = {
            intent: "STORE",  // Allowed values: "CHARGE", "STORE"
            billingContact: props.squareContact
        };
        // verify buyer
        verifyBuyer(nonce, verification_details);
    };

    const verifySavedPaymentMethod = (payment_method) => {
        // verify a saved card
        try {
            // givenName is only required field for verifyBuyer billingContact
            let givenName = payment_method?.Customer?.CardHolderName || props.squareContact.givenName;

            var verification_details = {
                intent: "CHARGE",  // Allowed values: "CHARGE", "STORE"
                amount: props.PreAuthAmount,
                currencyCode: props.Currency,
                billingContact: {
                    givenName: givenName
                }
            };
            // verify buyer
            verifyBuyer(payment_method.ID, verification_details);
        }
        catch (err) {
            // since verification token is only required for EU we'll just bypass it
            console.log(err);
        }
    };

    const verifyBuyer = (payment_token, verification_details) => {
        try {
            paymentForm.verifyBuyer(
                payment_token,
                verification_details,
                function (err, verification) {
                    if (err == null) {
                        // success
                        setVerificationToken(verification.token);
                    } else {
                        // err
                        console.log(err);
                        props.setError("Buyer verification failed: " + err.type + ": " + err.message + ".");
                    }
                });
        } catch (typeError) {
            // critical err
            console.log(typeError);
            props.setError("Buyer verification failed. Please verify your Billing Address and Card Information.");
        }
    };

    return (
        <div>
            {props.loading && <LoadingRing sxBox={{ 'justify-content': 'center'}} />}
            <form id='payment-form'>
                <div className={(props.savedPayment ? ' hide' : '')}>
                    <div className="form-row">
                        <div className="form-element">
                            <label htmlFor="pfnumber">Card Number:</label>
                            <div id="sq-card-number"></div>
                        </div>
                        <div className="form-element">
                            <label htmlFor="pfexpiration">Expiration:</label>
                            <div id="sq-expiration-date"></div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-element">
                            <label htmlFor="pfcvv">CVV:</label>
                            <div id="sq-cvv"></div>
                        </div>
                        <div className="form-element">
                            <label htmlFor="pfexpiration">Postal Code:</label>
                            <div id="sq-postal-code"></div>
                        </div>
                    </div>
                </div>
                <div id='credit-card-error' className="error" style={{ textAlign: 'center', marginBottom: '15px' }}>
                    {props.error && <>{props.error}</>}
                </div>
                <PaymentAuthorizationSubmitButtons
                    {...props}
                    submitForm={submitForm}
                />
            </form>
        </div>
    );
}

export default SquareForm;